interface Props {
  /** 주보호자 이름 (사진 없을 때 이니셜로 표시) */
  name?: string | null;
  /** 주보호자 프로필 사진 URL (있으면 사진, 없으면 이니셜) */
  imageUrl?: string | null;
  /** 배지 지름(px) */
  size?: number;
}

/**
 * 연동(가족) 펫의 주보호자 표식 — 펫 아바타 우측 하단 코너 배지.
 * 주보호자 프로필 사진이 있으면 사진을, 없으면 이름 이니셜을 원형으로 표시한다.
 */
export function LinkedOwnerBadge({ name, imageUrl, size = 18 }: Props) {
  const initial = name?.trim()?.charAt(0) ?? "";
  return (
    <span
      className="absolute -bottom-0.5 -right-0.5 flex items-center justify-center overflow-hidden rounded-full bg-[#1D9E75] font-medium text-white ring-2 ring-white"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.5) }}
      title={name ? `${name}님 반려견` : "가족 연동 반려견"}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={name ?? "주보호자"}
          className="h-full w-full object-cover"
        />
      ) : (
        initial
      )}
    </span>
  );
}
